import { useContext } from 'react';
import { FeatureFlagsContext } from '../components/FeatureFlagsContext';
export const useFeatureFlags = featureFlagNames => {
  const context = useContext(FeatureFlagsContext);
  if (context.loading) {
    return {
      flags: null,
      loading: true
    };
  }
  const {
    client,
    error
  } = context;
  return {
    error,
    flags: client.getFeatureFlags(featureFlagNames),
    loading: false
  };
};
export const useFeatureFlag = featureFlagName => {
  const context = useContext(FeatureFlagsContext);
  if (context.loading) {
    return {
      flag: null,
      loading: true
    };
  }

  // If featureFlagName is empty, we exclude the user from the experiment, without having split.io bucket them
  if (featureFlagName === '') {
    return {
      flag: 'excluded',
      loading: false
    };
  }
  const {
    client,
    error
  } = context;
  return {
    error,
    flag: client.getFeatureFlag(featureFlagName),
    loading: false
  };
};